<section>
  <header>
    <div class="row">
      <div class="col">
        <label class="label max-width" translate>language</label>
        <ngx-language-select></ngx-language-select>
      </div>
    </div>
    <h1 class="title" translate>login</h1>
    <p class="subtitle" translate>login_subtitle</p>
  </header>
  <form [attr.aria-label]="'login' | translate" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="row form-control-group">
      <div class="col">
        <label for="user-name" class="label form-required" translate>user_name</label>
        <input
          id="user-name"
          type="text"
          class="nb-input"
          [placeholder]="'user_name'  | translate"
          formControlName="username"
          nbInput
          fullWidth
        />
        <ngx-validation-message [group]="form" controlName="username" [validationMessages]="validationMessages"></ngx-validation-message>
      </div>
    </div>
    <div class="row form-control-group">
      <div class="col">
        <label for="password" class="label form-required" translate>
          password
        </label>
        <input
          id="password"
          type="password"
          class="nb-input"
          [placeholder]="'password' | translate"
          formControlName="password"
          nbInput
          fullWidth
        />
        <ngx-validation-message [group]="form" controlName="password" [validationMessages]="validationMessages"></ngx-validation-message>
      </div>
    </div>
    <div class="form-submit-group" *ngIf="{ loading: loading$ | async } as data">
      <button
        id="button-login"
        type="submit"
        [disabled]="data.loading"
        [nbSpinner]="data.loading"
        nbSpinnerSize="large"
        nbButton
        fullWidth
        size="large"
      >
        {{ 'login_button' | translate }}
      </button>
    </div>
  </form>
</section>
